module.exports = __webpack_public_path__ + "img/info.78fb983a.webp";